module.exports = __webpack_public_path__ + "static/media/icon-form-comm-log.48a2fb41.svg";